// extracted by mini-css-extract-plugin
module.exports = {"background":"sheet-renderer_background__3C8t7","container":"sheet-renderer_container__1T3Yb","card":"sheet-renderer_card__HzLl4","closeButton":"sheet-renderer_closeButton__2nOOY"};